import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BusinesLogicService } from './business-logic.service';

@Injectable()
export class SocketService {
  public sockets: Record<string, WebSocket> = {};
  private messageObservables: Record<string, Observable<any>> = {};
  private closeObservables: Record<string, Observable<any>> = {};
  private openObservables: Record<string, Observable<any>> = {};
  private SERVER_URL: string = '';

  public constructor(private _blogic: BusinesLogicService) {
    this.SERVER_URL = this._blogic.socketUrl;
  }

  public initSocket(desk_id: string, socket: string): void {
    if (this.isSocketClosed(socket)) {
      const endpoint = this.getEndpointForSocket(socket);
      this.createSocketConnection(socket, desk_id, endpoint);
      this.setupSocketCloseHandler(socket);
      this.initObservables(socket);
    }
  }

  private isSocketClosed(socketType: string): boolean {
    return !this.sockets[socketType] || this.sockets[socketType].readyState === WebSocket.CLOSED;
  }

  private getEndpointForSocket(socketType: string): string {
    return socketType === 'msgSocket' ? 'chat' : 'notify';
  }

  private createSocketConnection(socketType: string, deskId: string, endpoint: string): void {
    const url = `${this.SERVER_URL}${endpoint}?id=${deskId}`;
    this.sockets[socketType] = new WebSocket(url);
  }

  private setupSocketCloseHandler(socketType: string): void {
    this.sockets[socketType].onclose = () => {
      this.sockets[socketType] = null;
    };
  }

  public clearSocket(socket: string) {
    if (this.isSocketOpen(socket)) {
      this.sockets[socket].close();
    }
    this.sockets[socket] = null;
  }

  private isSocketOpen(socketType: string): boolean {
    return this.sockets[socketType] && this.sockets[socketType].readyState === WebSocket.OPEN;
  }

  private initObservables(socket): void {
    this.messageObservables[socket] = this.createMessageObservable(socket);
    this.closeObservables[socket] = this.createCloseObservable(socket);
    this.openObservables[socket] = this.createOpenObservable(socket);
  }

  public send(message: any, socket: string): void {
    this.sockets[socket].send(JSON.stringify(message));
  }

  public getMessageObservable(socket: string): Observable<any> {
    return this.messageObservables[socket];
  }

  public getOpenObservable(socket: string): Observable<any> {
    return this.openObservables[socket];
  }

  public getCloseObservable(socket: string): Observable<any> {
    return this.closeObservables[socket];
  }

  private createMessageObservable(socket: string): Observable<any> {
    return new Observable<any>(observer => {
      this.sockets[socket].onmessage = (data: any) => {
        observer.next(JSON.parse(data.data));
      };
    }).share();
  }

  private createCloseObservable(socket: string): Observable<any> {
    return new Observable(observer => {
      this.sockets[socket].onclose = (data) => {
        observer.next(data);
      };
    }).share();
  }

  private createOpenObservable(socket: string): Observable<any> {
    return new Observable(observer => {
      this.sockets[socket].onopen = (data) => {
        observer.next(data);
      };
    }).share();
  }

}
